module.exports = __webpack_public_path__ + "img/16-11.cfd26f4b.jpg";